// extracted by mini-css-extract-plugin
module.exports = {"notFoundOuter":"PageNotFound_notFoundOuter__3Dx4f","notFoundTextBox":"PageNotFound_notFoundTextBox__fahBh","notFoundIconBox":"PageNotFound_notFoundIconBox__32Bzl"};